<div class="dialog-container">
  <mat-dialog-content class="modal-content">
    <div class="contact-dialog-box d-flex flex-column">
      <div class="contact-dialog-upper-section">
        <span class="alert-msg">Alert message!</span>
        <div class="crossmark-container">
          <mat-dialog-actions>
            <div class="close-button" mat-button mat-dialog-close>
              <svg
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  id="cross-icon"
                  d="M14.0003 27.3334C6.63653 27.3334 0.666992 21.3638 0.666992 14.0001C0.666992 6.63628 6.63653 0.666748 14.0003 0.666748C21.3641 0.666748 27.3337 6.63628 27.3337 14.0001C27.3337 21.3638 21.3641 27.3334 14.0003 27.3334ZM14.0003 24.6668C19.8914 24.6668 24.667 19.8912 24.667 14.0001C24.667 8.10904 19.8914 3.33342 14.0003 3.33342C8.10929 3.33342 3.33366 8.10904 3.33366 14.0001C3.33366 19.8912 8.10929 24.6668 14.0003 24.6668ZM14.0003 12.1145L17.7715 8.34323L19.6571 10.2288L15.8859 14.0001L19.6571 17.7713L17.7715 19.6569L14.0003 15.8857L10.2291 19.6569L8.34347 17.7713L12.1147 14.0001L8.34347 10.2288L10.2291 8.34323L14.0003 12.1145Z"
                  fill="white"
                />
              </svg>
            </div>
          </mat-dialog-actions>
        </div>
      </div>
      <span class="upper-text"
        >Are you sure you want to view the contact details?</span
      >
      <div
        class="lower-text-container d-flex flex-column"
        style="margin-top: 24px"
      >
        <span class="lower-text"
          >Sole responsibility : You understand and accept that you are solely
          responsible for any consequences that may arise from providing access
          to the phone number.
        </span>
        <span class="lower-text"
          >Misuse Disclaimer: If you misuse this number you are responsible, and
          strict actions will be taken.
        </span>
        <span class="lower-text"
          >Privacy concerns: You are aware that sharing personal information may
          involve certain privacy risks, and you willingly assume those risks.
        </span>
      </div>
      @if(checkNumber){
      <span class="ph-number-text" (click)="copyToClipboard()">+91 {{ phnNumber }}</span>
      }@else{
      <button class="contact-button dp-primary-btn" (click)="showNumber()">
        Yes, view contact
      </button>
      }
    </div>
  </mat-dialog-content>
</div>
<app-loader [isLoading]="isLoading"></app-loader>
